import { createFileRoute } from '@tanstack/react-router';
import { EditorDoPapel } from '@/features/funcoes/componentes/EditorDoPapel';
import { rotaDeTela } from '@/features/permissoes/guardas';

/** Novo papel: cria já com as telas do menu e segue na edição dele. */
export const Route = createFileRoute('/_autenticado/equipe/funcoes/nova')({
  ...rotaDeTela('equipe.funcoes'),
  staticData: { tela: 'equipe.funcoes', titulo: 'Novo papel' },
  component: EditorDoPapel,
});
